import React from "react";
import { Button } from ".";

const RetreatCard = ({
  image,
  date,
  place,
  price,
  link,
}) => {

  const isDisabled =
    !date ||
    date ===
      "To be announced soon" ||
    !place ||
    place ===
      "To be announced soon";

  return (
    <div
      className="
        group
        relative
        overflow-hidden
        rounded-[34px]
        bg-white/70
        backdrop-blur-2xl
        border
        border-white/40
        shadow-[0_30px_80px_rgba(20,10,0,.08)]
        transition-all
        duration-500
        hover:-translate-y-2
      "
    >

      {/* GLOW */}
      <div
        className="
          absolute
          top-0
          right-0
          w-52
          h-52
          bg-[#F4D8BE]/20
          blur-3xl
          rounded-full
        "
      />

      <div
        className="
          relative
          z-10
          flex
          flex-col
          lg:flex-row
        "
      >

        {/* IMAGE SIDE */}
        <div
          className="
            relative
            w-full
            lg:w-[42%]
            overflow-hidden
          "
        >

          {image ? (
            <img
              src={image}
              alt="Retreat"
              className="
                w-full
                h-[320px]
                lg:h-full
                object-cover
                transition-transform
                duration-700
                group-hover:scale-105
              "
            />
          ) : (
            <div
              className="
                h-[320px]
                flex
                items-center
                justify-center
                bg-[#EFE3D5]
              "
            >
              <p
                className="
                  text-[#7B6E64]
                  italic
                  text-sm
                "
              >
                Image coming soon
              </p>
            </div>
          )}

          {/* IMAGE OVERLAY */}
          <div
            className="
              absolute
              inset-0
              bg-gradient-to-t
              from-black/40
              via-black/5
              to-transparent
            "
          />
        </div>

        {/* CONTENT */}
        <div
          className="
            w-full
            lg:w-[58%]
            p-7
            md:p-8
            flex
            flex-col
            justify-center
          "
        >

          {/* LABEL */}
          <div
            className="
              inline-flex
              items-center
              px-4
              py-2
              rounded-full
              bg-[#FFF4E8]
              border
              border-[#F3DDC7]
              text-[#C26B2E]
              text-[11px]
              tracking-[.18em]
              uppercase
              font-medium
              mb-7
              w-fit
            "
          >
            Upcoming Retreat
          </div>

          {/* INFO GRID */}
          <div className="space-y-6">

            {/* DATE */}
            <div>

              <div
                className="
                  text-[#B08968]
                  text-[11px]
                  tracking-[.18em]
                  uppercase
                  mb-2
                "
              >
                Date
              </div>

              <p
                className="
                  text-[#2A140D]
                  text-[20px]
                  leading-[1.4]
                  tracking-[-0.02em]
                "
              >
                {date ||
                  "To be announced soon"}
              </p>
            </div>

            {/* PLACE */}
            <div>

              <div
                className="
                  text-[#B08968]
                  text-[11px]
                  tracking-[.18em]
                  uppercase
                  mb-2
                "
              >
                Place
              </div>

              <p
                className="
                  text-[#5F5751]
                  text-[16px]
                  leading-8
                "
              >
                {place ||
                  "To be announced soon"}
              </p>
            </div>

            {/* PRICE */}
            <div>

              <div
                className="
                  text-[#B08968]
                  text-[11px]
                  tracking-[.18em]
                  uppercase
                  mb-2
                "
              >
                Investment
              </div>

              <p
                className="
                  text-[#5F5751]
                  text-[16px]
                  leading-8
                "
              >
                {price || "TBD"}
              </p>
            </div>
          </div>

          {/* BUTTON */}
          <div className="mt-8">

            <Button
              variant="primary"
              size="sm"
              text={
                isDisabled
                  ? "Coming Soon"
                  : "Reserve Your Spot →"
              }
              link={link}
              disabled={isDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetreatCard;
